import { on } from "@ngrx/store";
import { cloneDeep } from "lodash";
import { JobToolState } from "src/app/job/job-tool.reducer";

import { LoadingState } from "../../../../utilities/state.util";

import { JobAgentActions } from "./job-agent.actions";

export const jobAgentReducers = [
  on(JobAgentActions.employeeLoaded, (state: JobToolState, { employee, role }): JobToolState => {

    const selectedEmployees = cloneDeep(state.selectedEmployees);

    selectedEmployees[role] = employee;

    return {
      ...state,
      selectedEmployees,
    }
  }),
  on(JobAgentActions.employeeAutocompleteInputChanged, (state: JobToolState, { role }): JobToolState => {

    const selectedEmployees = cloneDeep(state.selectedEmployees);

    delete selectedEmployees[role];

    return {
      ...state,
      selectedEmployees,
    }
  }),
  on(JobAgentActions.employeeSelected, (state: JobToolState, { employee, role }): JobToolState => {

    const selectedEmployees = cloneDeep(state.selectedEmployees);
    const isEditRole = { ...state.isEditRole };
    const employeeSearch = { ...state.employeeSearch };

    selectedEmployees[role] = employee;
    delete isEditRole[role];
    delete employeeSearch[role];

    return {
      ...state,
      selectedEmployees,
      isEditRole,
      employeeSearch,
      callState: {
        ...state.callState,
        Agent: LoadingState.MUTATING,
      },
    }
  }),
  on(
    JobAgentActions.unassignAgentMenuItemClicked,
    (state: JobToolState, { role }): JobToolState => {

      const selectedEmployees = cloneDeep(state.selectedEmployees);

      delete selectedEmployees[role];

      return {
        ...state,
        selectedEmployees,
      }
    },
  ),
  on(
    JobAgentActions.addAgentButtonClicked,
    JobAgentActions.changeAgentMenuItemClicked,
    (state: JobToolState, { role }): JobToolState => {

      const isEditRole = { ...state.isEditRole };;

      isEditRole[role] = true;

      return {
        ...state,
        isEditRole,
      }
    },
  ),
  on(JobAgentActions.clickedOutside, (state: JobToolState, { role }): JobToolState => {

    const selectedEmployees = cloneDeep(state.selectedEmployees);
    const isEditRole = { ...state.isEditRole };;
    const employeeSearch = { ...state.employeeSearch };

    delete selectedEmployees[role];
    delete isEditRole[role];
    delete employeeSearch[role];

    return {
      ...state,
      selectedEmployees,
      isEditRole,
      employeeSearch,
    }
  }),
  on(JobAgentActions.employeeAutocompleteSearchFired, (state: JobToolState, { query, role }): JobToolState => {

    const employeeSearch = { ...state.employeeSearch };

    employeeSearch[role] = query;

    let employeeSuggestions = state.employeeSuggestions;

    // Let the autocomplete component that search is completed
    if (query.trim().length === 0) {
      employeeSuggestions = [];
    }

    return {
      ...state,
      employeeSearch,
      employeeSuggestions,
    }
  }),
  on(JobAgentActions.searchEmployeesSuccess, (state: JobToolState, { employees }): JobToolState => {
    return {
      ...state,
      employeeSuggestions: employees,
    }
  }),
  on(
    JobAgentActions.assignAgentSuccess,
    JobAgentActions.unassignAgentSuccess,
    (state: JobToolState): JobToolState => {
      return {
        ...state,
        callState: {
          ...state.callState,
          Agent: LoadingState.MUTATED,
        },
      }
    }
  ),
  on(
    JobAgentActions.assignAgentError,
    JobAgentActions.unassignAgentError,
    (state: JobToolState, { error }): JobToolState => {
      return {
        ...state,
        callState: {
          ...state.callState,
          Agent: { error }
        }
      }
    }
  ),
]; 
